import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from 'components/ResponsiveImage';
import BackgroundMedia from 'components/BackgroundMedia';
import Link, { LINK_ACTION_TYPES } from 'components/Link';
import { breakpoints } from 'js/breakpoints';
import {
  getFullWidthImageSourcesMobile,
  getFullWidthImageSourcesDesktop,
} from 'js/image-sources';
import './CountryPageHero.scss';

const CountryPageHero = ({ heading, intro, image, seeAllLink }) => {
  return (
    <div className="country-page-hero wrapper">
      {image && (
        <div className="country-page-hero__image">
          <BackgroundMedia
            image={image}
            imageFetchPriority="high"
            imageSources={[
              ...getFullWidthImageSourcesMobile(293, 767),
              ...getFullWidthImageSourcesDesktop(450, 767, 1280),
              {
                width: 1560,
                height: 450,
                media: breakpoints.xl,
              },
            ]}
          />
        </div>
      )}
      <div className="country-page-hero__text-container">
        {heading && <h1 className="country-page-hero__heading">{heading}</h1>}
        {intro && <div className="country-page-hero__intro">{intro}</div>}
        {seeAllLink && (
          <div className="country-page-hero__see-all-link-holder">
            <Link {...seeAllLink} action={LINK_ACTION_TYPES.back} />
          </div>
        )}
      </div>
    </div>
  );
};

CountryPageHero.propTypes = {
  heading: PropTypes.string,
  intro: PropTypes.string,
  image: PropTypes.exact(ResponsiveImage.propTypes),
  seeAllLink: PropTypes.exact(Link.propTypes),
};

export default CountryPageHero;
